import React, { ReactElement, useContext } from 'react';
import { Immutable } from '@wds/utils';
import { Sheet } from '@wds/sheet';
import { Typography } from '@wds/typography';
import { List } from '@wds/list';
import { Box } from '@wds/box';
import { IconHelpFilled } from '@wds/icons';
import { t, defineMessages } from '@sm/intl';
import { Responsive } from '@wds/responsive';
import { MenuItems } from './MenuItems';
import HeaderContext from '../../HeaderContext';
import { NavButton } from '../nav-button';
import { getResourcesItems } from '../../../components/Drawer/getDrawerData';

const COPYHELP = defineMessages({
  HELP: {
    id: 'HelpMenu.help',
    defaultMessage: 'Help',
    description:
      '[Type: Label][Vis.: high] - This is the Help title of the side menu.',
  },
});

export type HelpMenuProps = Immutable<{
  showHelp: boolean;
}> & {
  toggleHelp(): void;
};

const HelpMenu = ({ showHelp, toggleHelp }: HelpMenuProps): ReactElement => {
  const { lang } = useContext(HeaderContext);
  const itemsData = getResourcesItems(lang) || [];

  return (
    <Responsive minWidth="xl">
      {matches =>
        matches ? (
          <>
            <NavButton
              onClick={toggleHelp}
              label="Open Help menu"
              active={showHelp}
            >
              <IconHelpFilled title="help icon" size="lg" />
            </NavButton>
            <Sheet show={showHelp} onClose={toggleHelp} offsetTop={48}>
              <Box pt={5} pl={5} pr={5}>
                <Typography variant="sectionTitle">
                  {t(COPYHELP.HELP)}
                </Typography>
              </Box>
              <List interactive noRules>
                {itemsData.map(
                  props => props && <MenuItems {...props} key={props.title} />
                )}
              </List>
            </Sheet>
          </>
        ) : (
          itemsData.map(
            props => props && <MenuItems {...props} key={props.title} />
          )
        )
      }
    </Responsive>
  );
};

export default HelpMenu;
export { HelpMenu };
